import type {
  GetLocationBaseResponse,
  GetUserResponse,
} from "@/openapi/generated/models";

export function getStaffWorkLocations(
  staff: Pick<GetUserResponse, "workLocations">,
): GetLocationBaseResponse[] {
  return staff.workLocations ?? [];
}

export function getStaffWorkLocationIds(
  staff: Pick<GetUserResponse, "workLocations">,
): number[] {
  return getStaffWorkLocations(staff)
    .map((loc) => Number(loc.locationId))
    .filter((id) => !Number.isNaN(id) && id > 0);
}

/** OpenAPI codegen uses GoogleLoginCallbackTidParameter for int arrays - normalize to numbers. */
export function normalizeWorkLocationIds(
  ids: unknown,
): number[] | null | undefined {
  if (ids === undefined) return undefined;
  if (ids === null) return null;
  if (!Array.isArray(ids)) return undefined;

  return ids
    .map((id) => Number(id))
    .filter((id) => !Number.isNaN(id) && id > 0);
}

export function getStaffWorkLocationNames(
  staff: Pick<GetUserResponse, "workLocations">,
  locationIdToName?: Record<number, string>,
): string[] {
  const fromApi = getStaffWorkLocations(staff)
    .map((loc) => loc.name?.trim())
    .filter((name): name is string => !!name);
  if (fromApi.length > 0) return fromApi;

  if (!locationIdToName) return [];
  return getStaffWorkLocationIds(staff)
    .map((id) => locationIdToName[id])
    .filter((name): name is string => !!name);
}

export function formatStaffWorkLocationsDisplay(
  staff: Pick<GetUserResponse, "workLocations">,
  locationIdToName?: Record<number, string>,
): string | null {
  const names = getStaffWorkLocationNames(staff, locationIdToName);
  return names.length > 0 ? names.join(", ") : null;
}
